module.exports = __webpack_public_path__ + "static/media/icon_calandar.1890f5a0.svg";